export default __webpack_public_path__ + "static/media/Users_icon.4a10ed5c.svg";